import { r, createSender } from '@/plugins/resource/resource'

const MODEL = 'registration'

export const userRegister = r('/{type}/create/', MODEL, createSender)
export const userRequestConfirmation = r('/{type}/request-confirmation/', MODEL, createSender)